module.exports = __webpack_public_path__ + "img/yhgh6.914dd1ea.png";